
module.exports = {
  // TODO: change your profile information here
  name: "Chandan Mishra",
  greeting: "Hey 👋",
  greetingDescription: "I'm Chandan Mishra and I'm a Software Engineer!",
  githubUrl: "https://github.com/TheDarkKnight-1",
  linkedinUrl: "kedin.com/in/chandan-mishra-b997aa187/",
  cvLink: "https://drive.google.com/drive/folders/1ynA9h9zLaaWK9arCrA2pGYC8sFIe5z22?usp=sharing",
};
